package horcrux.common.api.dtos.types

import arrow.core.Either
import horcrux.common.HorcruxEither
import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.UniqueValueClass
import horcrux.common.api.APILimits
import horcrux.common.utils.Validatable
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

data class InvalidDocumentName(val documentName: DocumentName, override val cause: Throwable) :
    HorcruxRequestSimpleError(cause, HttpStatusCode.UnprocessableEntity)

@Serializable
@JvmInline
value class DocumentName(override val value: String) : UniqueValueClass<String, DocumentName>,
    Validatable<DocumentName> {
    override fun validate(): HorcruxEither<DocumentName> = Either.catch {
        require(this.value.length in APILimits.MIN_DOCUMENT_NAME_LENGTH..APILimits.MAX_DOCUMENT_NAME_LENGTH) {
            "DocumentName must be between ${APILimits.MIN_DOCUMENT_NAME_LENGTH} and ${APILimits.MAX_DOCUMENT_NAME_LENGTH} characters"
        }
        this
    }.mapLeft { InvalidDocumentName(this, it) }

    companion object {
        fun truncate(value: String): DocumentName =
            DocumentName(value.take(APILimits.MAX_DOCUMENT_NAME_LENGTH))
    }
}
